// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JEeq","footer":"styles_footer__2A7Ee","passCodeTooltip":"styles_passCodeTooltip__1cbJ0"};